<template>
    <div class="broadcast-sended-details">
        <div class="broadcast-sended-details-title">Gönderim Durumları</div>
        <div class="broadcast-sended-details-table">
            <SupsisTable :columns="cols" :rows="details" />
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import { mapState } from "vuex";
import SupsisTable from "../../../../../components/SupsisTable.vue";
import SupsisButton from "../../../Settings/components/SupsisButton.vue";

export default Vue.extend({
    name: "BroadcastSendedDetails",
    components: { SupsisButton, SupsisTable },
    props: {
        details: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            cols: [
                {
                    field: "number",
                    key: "number",
                    title: "Telefon Numarası",
                    width: 50,
                    align: "left",
                    renderBodyCell: ({ row }) => {
                        return <div>{row.number}</div>;
                    },
                },
                {
                    key: "success",
                    field: "success",
                    title: "Durum",
                    width: 50,
                    align: "left",
                    renderBodyCell: ({ row }) => {
                        return <div>{row.success ? "Başarılı" : "Başarısız"}</div>;
                    },
                },
                {
                    key: "failureReason",
                    field: "failureReason",
                    title: "Hata Mesajı",
                    width: 50,
                    align: "left",
                    renderBodyCell: ({ row }) => {
                        return <div>{row.failureReason || "N/A"}</div>;
                    },
                },
            ],
        };
    },
    computed: {
        ...mapState({
            siteId: (state) => state.site.site._id,
            user: (state) => state.auth.user,
        }),
    },
});
</script>

<style scoped lang="scss">
.broadcast-sended-details {
    display: flex;
    width: 100%;
    flex-direction: column;
    height: 100%;
    gap: 10px;

    &-title {
        font-size: 18px;
        font-weight: bold;
    }

    &-table {
        height: 70vh;
        overflow-y: auto;
        overflow-x: hidden;
    }
}
</style>
